import React from 'react';
import { useFormContext } from 'react-hook-form';

const Radio = ({
    label,
    name,
    value,
    rules = {},
    className = '',
    labelClassName = '',
    ...rest
}) => {
    const { register, } = useFormContext();

    const styles = {
        radioInput: {
            marginRight: '5px'
        }
    };

    return (
        <label className={`radio-label ${labelClassName}`}>
            <input
                type="radio"
                name={name}
                value={value}
                {...register(name, rules)}
                className={` ${className}`}
                style={ styles.radioInput }
                {...rest}
            />
            {label}
        </label>
    );
};

export default Radio;
